import React, {useState} from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

const Ticker = ({className, ...rest}) => {
    const [viewPortEntered, setViewPortEntered] = useState(false);

    return (
        <CountUp {...rest} start={viewPortEntered ? null : 0} duration={7.5} useEasing={true}>
            {({countUpRef}) => {
                return (
                    <VisibilitySensor
                        active={!viewPortEntered}
                        onChange={isVisible => {
                            if (isVisible) {
                                setViewPortEntered(true);
                            }
                        }}
                        delayedCall
                    >
                        <h3 className="display-1 fw-bold" ref={countUpRef} />
                    </VisibilitySensor>
                );
            }}
        </CountUp>
    );
};

export default Ticker;
